import axios from 'axios'
import { DESTROY_USER_ACCOUNT_URL } from '../helpers/urls'
import {
  removeGleapStorage,
  removeUserAnonymousID,
  removeUserID,
} from '../helpers/UserLocalStorageHelper'
import { GleapRedactUser } from './GleapService'
import { Dispatch, SetStateAction } from 'react'
import { User } from '../models/User'

const deleteUser = (
  setIsLogged: Dispatch<SetStateAction<boolean | undefined>>,
  updateCurrentUser: (user: User | undefined) => void
) =>
  axios.delete(`${DESTROY_USER_ACCOUNT_URL}?confirmed=true`).finally(() => {
    // Third party before removing local data
    GleapRedactUser()

    // Store data
    setIsLogged(false)
    updateCurrentUser(undefined)

    // Clear local storage data
    removeUserID()
    removeUserAnonymousID()
    removeGleapStorage()
  })

export { deleteUser }
